<template>
    <div class="ist-body">
        <DxDataGrid :data-source="rows" ref="gridRef" :key-expr="keyExpr" :show-borders="true"
            :allow-column-resizing="true" :column-auto-width="false" height="100%"
            :show-row-lines="true" :hover-state-enabled="true"
            :no-data-text="complet ? 'Nu există istoric.' : 'Nu există istoric pentru luna selectată.'">
            <DxScrolling mode="virtual" column-rendering-mode="virtual" :row-page-size="100" />
            <DxRemoteOperations v-if="complet" :paging="true" />
            <DxSorting mode="single" />
            <DxColumnFixing :enabled="true" />
            <DxSearchPanel :visible="true" :width="200" placeholder="Caută…" />
            <DxExport :enabled="true" :formats="['xlsx']" />

            <DxColumn v-if="complet" data-field="Data" caption="Luna" data-type="date" format="MM.yyyy"
                :width="80" :fixed="true" sort-order="desc" />
            <DxColumn data-field="CodAngajat" caption="Marca" :width="80" :fixed="true" />
            <DxColumn data-field="NumeAngajat" caption="Nume" :width="200" :fixed="true" />
            <DxColumn data-field="Post" caption="Post" :width="160" :visible="false" />
            <DxColumn v-for="z in zile" :key="z" :data-field="'Z' + z" :caption="String(z)" :width="40"
                alignment="center" :css-class="weekendClass(z)" />
            <DxColumn data-field="Total" caption="Total" :width="70" :fixed="true" :fixed-position="'right'"
                alignment="center" css-class="col-total" />
            <DxColumn data-field="CO" caption="CO" :width="50" :fixed="true" :fixed-position="'right'" alignment="center" />
            <DxColumn data-field="CM" caption="CM" :width="50" :fixed="true" :fixed-position="'right'" alignment="center" />
            <DxColumn data-field="CFP" caption="CFP" :width="50" alignment="center" />
            <DxColumn data-field="N" caption="N" :width="45" alignment="center" />
            <DxColumn data-field="X" caption="X" :width="45" alignment="center" />
            <DxColumn data-field="OreNelucrate" caption="Ore Nelucr." :width="90" alignment="center" :visible="complet" />
            <DxColumn data-field="ValSup50" caption="Sup50" :width="60" alignment="center" :visible="complet" />
            <DxColumn data-field="ValSup100" caption="Sup100" :width="60" alignment="center" :visible="complet" />
            <DxColumn data-field="ValSupNoapte" caption="Noapte" :width="60" alignment="center" :visible="complet" />
        </DxDataGrid>
    </div>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue';
import {
    DxDataGrid, DxColumn, DxScrolling, DxSorting, DxColumnFixing, DxExport, DxSearchPanel, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import notify from 'devextreme/ui/notify';
import RU_Pontaj from '@/services/RU/RU_Pontaj';

export default defineComponent({
    components: { DxDataGrid, DxColumn, DxScrolling, DxSorting, DxColumnFixing, DxExport, DxSearchPanel, DxRemoteOperations },
    props: {
        an: { type: Number, required: true },
        luna: { type: Number, required: true },
        empId: { type: String, default: null },
        complet: { type: Boolean, default: false },
    },
    data() {
        // Complet = toate lunile → mereu 31 coloane zi + cheie compusa (IDAng + Data)
        return {
            gridRef: ref(null),
            loading: false,
            zile: [] as number[],
            rows: [] as any,
            keyExpr: (this.complet ? ['IDAng', 'Data'] : 'IDAng') as string | string[],
        };
    },
    watch: {
        an() { if (!this.complet) this.incarca(); },
        luna() { if (!this.complet) this.incarca(); },
    },
    methods: {
        weekendClass(zi: number): string {
            // In modul complet nu putem colora corect (mai multe luni) → fara clasa
            if (this.complet) return '';
            const d = new Date(this.an, this.luna - 1, zi).getDay();
            return (d === 0 || d === 6) ? 'col-weekend' : '';
        },
        async incarca() {
            this.loading = true;
            try {
                if (this.complet) {
                    // Tot istoricul: CustomStore paginat server-side (incarcare rapida, virtual scroll)
                    this.zile = Array.from({ length: 31 }, (_, i) => i + 1);
                    this.rows = new CustomStore({
                        key: ['IDAng', 'Data'],
                        load: async (opts: any) => {
                            const r = await RU_Pontaj.getPontajIstoricComplet(opts.skip ?? 0, opts.take ?? 100);
                            return { data: r?.data?.data ?? [], totalCount: r?.data?.totalCount ?? 0 };
                        },
                    }) as any;
                    this.loading = false;
                    return;
                } else {
                    const luna = String(this.luna).padStart(2, '0');
                    const dataStart = `${this.an}-${luna}-01`;
                    const nrZile = new Date(this.an, this.luna, 0).getDate();
                    this.zile = Array.from({ length: nrZile }, (_, i) => i + 1);
                    const r = await RU_Pontaj.getPontajIstoric(dataStart);
                    this.rows = r?.data ?? [];
                }
            } catch (e) {
                console.error(e);
                notify('Eroare la încărcarea istoricului!', 'error', 3000);
                this.rows = [];
            } finally { this.loading = false; }
        },
    },
    mounted() { this.incarca(); },
});
</script>
<style scoped>
.ist-body { height: 100%; }
:deep(.col-weekend) { background: #f1f5f9; }
:deep(.col-total) { font-weight: 700; background: #ecfdf5; color: #065f46; }
</style>
